import React from 'react';
import PropTypes from 'prop-types';

import {withRouter} from 'react-router';

import Helmet from 'react-helmet';
import {channelImageUrl} from '../../containers/channelUtils/ChannelImage';

const SITE_TITLE = 'PrimeCarry';

function Meta({title, fallbackTitle, description, keywords, type = 'article', image, location}) {
  return (
    <Helmet titleTemplate={title ? '%s' : `%s - ${SITE_TITLE}`}>
      {(!title && !!fallbackTitle) && <title>{fallbackTitle}</title>}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description}/>}
      {keywords && <meta name="keywords" content={keywords}/>}

      <meta property="og:type" content={type}/>
      <meta property="og:site_name" content={SITE_TITLE}/>
      <meta property="og:title" content={title || fallbackTitle && `${fallbackTitle} - ${SITE_TITLE}` || SITE_TITLE}/>
      <meta property="og:image" content={channelImageUrl(image)}/>
      <meta property="og:description" content={description || SITE_TITLE}/>
      <meta property="og:url" content={process.env.PUBLIC_URL + location.pathname}/>

      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:site" content={SITE_TITLE}/>
      {/* TODO: Fix twitor handle */}
      {/*<meta name="twitter:creator" content="@Boosthive"/>*/}
      <meta name="twitter:title" content={title || fallbackTitle && `${fallbackTitle} - ${SITE_TITLE}` || SITE_TITLE}/>
      <meta name="twitter:description" content={description || SITE_TITLE}/>
      <meta name="twitter:image" content={channelImageUrl(image)}/>
    </Helmet>
  );
}

Meta.propTypes = {
  title: PropTypes.string,
  fallbackTitle: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
};

export default withRouter(Meta);



// WEBPACK FOOTER //
// ./components/meta/Meta.js